import get from 'lodash/get';

export default {
    computed: {
        campaignUrl() {
            return `/api/v1/campaigns/${this.campaignParamId}?expand[]=brand&expand[]=tasks&expand[]=assets&expand[]=compensation_settings&expand[]=products&expand[]=product_categories&expand[]=content_rights`;
        },
        affiliateLinkUrl() {
            return `/api/v1/contacts/${this.contactId}/campaigns/${this.campaignParamId}/affiliate-link`;
        },
        discountCodesUrl() {
            return `/api/v1/contacts/${this.contactId}/campaigns/${this.campaignParamId}/discount-codes`;
        },
        campaignParamId() {
            return this.$route.params.campaign_id;
        },
        campaignId() {
            return get(this.campaign, 'id');
        },
        isCampaignDirty() {
            return this.campaignId !== this.campaignParamId || !this.campaign;
        },
        affiliateLink() {
            return this.$root.v2.affiliateLink;
        },
        discountCodes() {
            return this.$root.v2.discountCodes;
        },
        campaign() {
            return this.$root.v2.campaign;
        }
    },
    methods: {
        loadCampaign() {
            if (!this.isCampaignDirty && this.campaign) {
                return Promise.resolve();
            }

            return this.$http.get(this.campaignUrl).then((res) => {
                this.updateCampaignState(res.data);
            });
        },
        updateCampaignState(campaign) {
            this.$root.v2.campaign = campaign;
        },
        loadAffiliateLink() {
            if (!this.isCampaignDirty && this.affiliateLink) {
                return Promise.resolve();
            }

            return this.$http
                .get(this.affiliateLinkUrl)
                .then((res) => (this.$root.v2.affiliateLink = res.data.short_url));
        },
        loadDiscountCodes() {
            if (!this.isCampaignDirty && this.discountCodes) {
                return Promise.resolve();
            }

            return this.$http
                .get(this.discountCodesUrl)
                .then((res) => (this.$root.v2.discountCodes = res.data.map((dc) => dc.code)));
        }
    }
};
